import { isDateType, eachDeep, getValueByPath, parseValue } from "../utils/helper";
import _ from "lodash";

export const processFilter = (filter, fixedFilter) => {
  const _filters = filter?.filters?.map(ff => { if (ff.origin) { return ff; } else { return { ...ff, origin: "none" }; } }).filter(f => f.origin === "none") || [];
  // const _fastFilters = fastFilter?.filters?.map(ff => { return { ...ff, origin: "fast" } });
  const _fixedFilters = fixedFilter?.filters?.map(ff => { return { ...ff, origin: "fixed" }; }) || [];

  return { ...filter, filters: [..._filters, ..._fixedFilters] };
};

export const getJoinValue = (x, selected) => {
  if (!_.isNil(x.Value)) {
    return parseValue(x.Value, x.Type);
  }
  const value = ["isnull", "isnotnull"].includes(x.Operator) ? null : _.uniq(getValueByPath(selected, x.ParentField)).join();

  if (value === "") {
    return x.Operator === "eq-ifexists" ? null : "-1";
  }
  return value;
};

export const buildWidth = (field, filterable) => {
  if (!filterable && field.compactWidth) {
    return field.compactWidth === 'auto' ? undefined : field.compactWidth;
  }
  if (field.width) {
    return field.width === 'auto' ? undefined : field.width;
  }

  switch (field.filter) {
    case 'numeric':
    case 'unitnumeric':
      return filterable ? 130 : 80;
    case 'boolean':
      return filterable ? 100 : 70;
    case 'cmd':
      return filterable ? 100 : 70;
    case 'date':
    case 'datetime':
    case 'dateinput':
    case 'timeinput':
    case 'datetimeinput':
    case '18':
    case '19':
    case '20':
      return filterable ? 190 : 105;
    case 'text':
    case 'enum':
    case 'buttongroup':
    case 'radio':
    default:
      return filterable ? 220 : 105;
  }
};

export const buildFilter = (schemaItem) => {
  switch (schemaItem.filter) {
    case 'numeric':
    case 'unitnumeric':
      return 'numeric';
    case 'boolean':
      return 'boolean';
    case 'date':
    case 'datetime':
    case 'dateinput':
    case 'datetimeinput':
    case '18':
    case '20':
      return 'date';
    case 'time':
    case 'timeinput':
    case '19':
      return null;
    case 'enum':
    case 'buttongroup':
    case 'radio':
    case 'group':
      return 'enum';
    case 'container':
    default:
      return 'text';
  }
};

export const buildMinResizableWidth = (field, filterable) => {
  if (!filterable && field.compactMinResizableWidth) {
    return field.compactMinResizableWidth;
  }
  if (field.minResizableWidth) {
    return field.minResizableWidth;
  }

  switch (field.filter) {
    case 'boolean':
    case 'cmd':
      return 40;
    case 'date':
      return 80;
    default:
      return 80;
  }
};

export const buildResetText = (resetValue) => {
  switch (resetValue) {
    case 3:
      return "Obnoviť predvolené nastavenia zoradenia formulára?";
    case 2:
      return "Obnoviť predvolené nastavenia vzhľadu formulára?";
    case 1:
    default:
      return "Obnoviť predvolené nastavenia formulára?";
  };
};

export const getField = (col) => {
  return col.field + (col.filter === "container" ? "." + col.textField : "");
};

export const getVisibleColumns = (schema) => {
  return _.sortBy(schema
    .filter(x => !x.disabled && !x.hidden)
    .map(col => ({ ...col, field: getField(col) }))
    , x => { return x.order ? x.order : 0; });
};

export const buildFormat = (x) => {
  if (isDateType(x.filter)) {
    return x.format ? x.format : (x.filter === 'time' ? "{0:HH:mm}" : "{0:dd.MM.yyyy}");
  }
  else if (x.filter === 'numeric' || x.filter === 'unitnumeric') {
    return x.format ? x.format : "{0:n}";
  }
  else return null;
};

export const prepareFilter = (filter, event, columns, frms) => {
  const item = event.nativeEvent && filter.filters[0];
  const enumCol = columns.find(col => item && col.field === item.field && col.filter === "enum" && col.primaryField !== "I_HOD");
  const filters = enumCol ? [item, ...filter.filters.filter(x => x.field !== enumCol.field + "." + enumCol.primaryField && x !== item)] : filter.filters;

  return {
    ...filter,
    filters: filters.map(x => {
      if (x.frmPod) {
        const frm = frms.find(f => f.Id === x.frmPod);
        x.joins = frm?.Joins.map(join => {
          return {
            childField: join.Field,
            parentField: join.ParentField,
            operator: join.Operator,
            childStl: join.ChildFieldStl,
            childId: join.ChildFieldId
          };
        });
        return x;
      }

      const col = columns.find(col => col.field === x.field);
      if (col && col.filter === "enum" && col.primaryField && col.primaryField !== "I_HOD") {
        x.field = x.field + "." + col.primaryField;
      }

      if (typeof x.value === 'string') {
        if (x.value.startsWith('=')) {
          x.operator = 'eq';
        }
        else if (x.value.startsWith('?')) {
          x.operator = 'isnull';
        }
        else if (x.value.startsWith('!?')) {
          x.operator = 'isnotnull';
        }
        else if (x.value.startsWith('*') || x.value.startsWith('%')) {
          x.operator = 'contains';
        }
        else if (x.value.startsWith('!*') || x.value.startsWith('!%')) {
          x.operator = 'doesnotcontain';
        }
        else if (x.value.startsWith('!=') || x.value.startsWith('!')) {
          x.operator = 'neq';
        }
      }

      if (col && col.filter === "numeric" && x.value) {
        if (x.operator === 'in' || x.operator === 'notin') {
          x.value = x.value.toString().replace(".", ",");
        } else if (typeof x.value === "string") {
          x.value = parseFloat(x.value.replace(",", "."));
        }
      }

      return x;
    })
  };
};

export const getFormType = (primaryField) => {
  switch (primaryField) {
    case "I_EMAIL":
      return 2;
    case "I_PRILOHA":
      return 3;
    default:
      return 1;
  }
};

export const getColumn = (columns, col) => {
  const field = getField(col);
  let column = undefined;
  eachDeep(columns, null, (item, parent) => {
    if (item.field && !item.disabled && !item.hidden && item.field === field && parent?.filter !== "container") {
      column = item;
    }
  });
  return column;
};

export const getSelectedItems = (selected, data, dataPrimaryField) => {
  return Object.entries(selected).reduce((acc, [key, value]) => {
    if (!value) return acc;

    const item = data.find(x => x[dataPrimaryField].toString() === key);
    if (item) acc.push({ ...item, selected: value });
    return acc;
  }, []);
};

export const getGridSelected = (selected, dataPrimaryField) => {
  let newGridSelected = {};
  selected.forEach(element => {
    const id = element[dataPrimaryField];
    newGridSelected[id] = element.selected ?? true;
  });
  return newGridSelected;
};